import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BulkDeleteEmailDocumentsMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars["ID"]> | Types.Scalars["ID"];
  deletionReason: Types.DeletionReason;
  deletionReasonText?: Types.InputMaybe<Types.Scalars["String"]>;
}>;

export type BulkDeleteEmailDocumentsMutation = {
  __typename?: "Mutation";
  bulkDeleteEmailDocuments: number;
};

export const BulkDeleteEmailDocumentsDocument = gql`
  mutation bulkDeleteEmailDocuments(
    $ids: [ID!]!
    $deletionReason: DeletionReason!
    $deletionReasonText: String
  ) {
    bulkDeleteEmailDocuments(
      ids: $ids
      deletionReason: $deletionReason
      deletionReasonText: $deletionReasonText
    )
  }
`;
export type BulkDeleteEmailDocumentsMutationFn = Apollo.MutationFunction<
  BulkDeleteEmailDocumentsMutation,
  BulkDeleteEmailDocumentsMutationVariables
>;

/**
 * __useBulkDeleteEmailDocumentsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteEmailDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteEmailDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteEmailDocumentsMutation, { data, loading, error }] = useBulkDeleteEmailDocumentsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      deletionReason: // value for 'deletionReason'
 *      deletionReasonText: // value for 'deletionReasonText'
 *   },
 * });
 */
export function useBulkDeleteEmailDocumentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkDeleteEmailDocumentsMutation,
    BulkDeleteEmailDocumentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkDeleteEmailDocumentsMutation,
    BulkDeleteEmailDocumentsMutationVariables
  >(BulkDeleteEmailDocumentsDocument, options);
}
export type BulkDeleteEmailDocumentsMutationHookResult = ReturnType<
  typeof useBulkDeleteEmailDocumentsMutation
>;
export type BulkDeleteEmailDocumentsMutationResult =
  Apollo.MutationResult<BulkDeleteEmailDocumentsMutation>;
export type BulkDeleteEmailDocumentsMutationOptions =
  Apollo.BaseMutationOptions<
    BulkDeleteEmailDocumentsMutation,
    BulkDeleteEmailDocumentsMutationVariables
  >;
